module.exports = __webpack_public_path__ + "703f45eb92bb0a14e805096b91972097.svg";